export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "expo-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "expo-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "expo-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "expo-themeWrapLive" */'./LiveThemeImporter'),
  },
};
